import { render, staticRenderFns } from "./LmParticipants.vue?vue&type=template&id=2a50f315"
import script from "./LmParticipants.vue?vue&type=script&lang=js"
export * from "./LmParticipants.vue?vue&type=script&lang=js"
import style0 from "./LmParticipants.vue?vue&type=style&index=0&id=2a50f315&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports